import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'

import type { Account } from '../../../../common/types'
import { shouldPerformTrackingEvent } from '../../../../tracking/utils'

type Cta = 'setup' | 'connectLinkedInProfile' | 'close'

function getOrganizationId(user: Account): string | null {
  if (!shouldPerformTrackingEvent({ user })) {
    return null
  }

  return user.currentOrganization?.id ?? null
}

export function trackLinkedInCapabilitiesModalViewed({
  linkedinProfileCount,
  user,
}: {
  linkedinProfileCount: number
  user: Account
}): void {
  const organizationId = getOrganizationId(user)
  if (!organizationId) {
    return
  }

  BufferTracker.linkedInCapabilitiesModalViewed({
    organizationId,
    clientName: Client.PublishWeb,
    hasLinkedInProfiles: linkedinProfileCount > 0,
    linkedinProfileCount,
  })
}

export function trackLinkedInCapabilitiesModalCtaClicked({
  channelId,
  cta,
  user,
}: {
  channelId?: string | null
  cta: Cta
  user: Account
}): void {
  const organizationId = getOrganizationId(user)
  if (!organizationId) {
    return
  }

  BufferTracker.linkedInCapabilitiesModalCTAClicked({
    organizationId,
    clientName: Client.PublishWeb,
    cta,
    channelId,
  })
}
